export const UpdateNisabActionTypes = {
  UPDATE_NISAB_LOADING: "UPDATE_NISAB_LOADING",
  UPDATE_NISAB_ERROR: "UPDATE_NISAB_ERROR",
  UPDATE_NISAB_SUCCESS: "UPDATE_NISAB_SUCCESS",
};
